import axios from 'axios';
import { API_CONFIG } from '../../constants';
import { GetUnsubscribeGroupsResponse } from '../../types/unsubscribeGroups/unsubscribeGroups.types';

const SERVER_URL = API_CONFIG.SERVER_URL;

export interface CreateUnsubscribePreferencePayload {
  unsubscribeAll: boolean;
  unsubscribeGroups?: string[];
}

export interface UpdateUnsubscribePreferencePayload {
  unsubscribeAll: boolean;
  unsubscribeGroups?: string[];
}

export const getPublicUnsubscribeGroups = async (
  workspaceId: string
): Promise<GetUnsubscribeGroupsResponse> => {
  try {
    const publicApi = axios.create({
      baseURL: SERVER_URL,
    });

    const response = await publicApi.get(
      `/unsubscribe-preference/unsubscribe-groups/public/${workspaceId}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching public unsubscribe groups:', error);
    throw error;
  }
};

export const createUnsubscribePreference = async (
  trackingId: string,
  payload: CreateUnsubscribePreferencePayload
): Promise<any> => {
  try {
    const publicApi = axios.create({
      baseURL: SERVER_URL,
    });

    const response = await publicApi.post(
      `/unsubscribe-preference/${trackingId}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error('Error creating unsubscribe preference:', error);
    throw error;
  }
};

export const getUnsubscribePreference = async (
  trackingId: string
): Promise<any> => {
  try {
    const publicApi = axios.create({
      baseURL: SERVER_URL,
    });

    const response = await publicApi.get(
      `/unsubscribe-preference/${trackingId}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching unsubscribe preference:', error);
    throw error;
  }
};

export const updateUnsubscribePreference = async (
  trackingId: string,
  payload: UpdateUnsubscribePreferencePayload
): Promise<any> => {
  try {
    const publicApi = axios.create({
      baseURL: SERVER_URL,
    });

    const response = await publicApi.put(
      `/unsubscribe-preference/${trackingId}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error('Error updating unsubscribe preference:', error);
    throw error;
  }
};
